import { createAction, props } from '@ngrx/store';
import { SubscriptionPlansModel } from 'src/models/module-wise/subscription/SubscriptionPlansModel';
import { SubscriptionPlan } from 'src/models/module-wise/subscription/SubscriptionPlan';

export const paginateSubscriptionPlans = createAction(
  '[ SUBSCRIPTION_PLAN ] Paginating'
);

export const loadSubscriptionPlans = createAction(
  '[ SUBSCRIPTION_PLAN ] Load Subscription Plan',
  // props<{ payload: SubscriptionPlan[], totalDocuments?: number }>()
  props<SubscriptionPlansModel>()
);

export const addSubscriptionPlan = createAction(
  '[ SUBSCRIPTION_PLAN ] Add Subscription Plan',
  props<{ payload: any | { status: string; _id: string } }>()
);

export const editSubscriptionPlan = createAction(
  '[ SUBSCRIPTION_PLAN ] Edit Subscription Plan',
  props<{ payload: any | { status: string; _id: string } }>()
);

export const deleteSubscriptionPlan = createAction(
  '[ SUBSCRIPTION_PLAN ] Delete Subscription Plan',
  props<{ payload: string[] }>()
);
